/* eslint-disable no-undef */

$(document).ready(() => {
	$('[data-open-popup="contact-us"]').bind('click', () => {
		togglePopup('contact-us');

  });
  $('.popup').bind('click', (e) => {
  		if(e.target === e.currentTarget) {
				togglePopup('contact-us');
			}
  });
 	$('.close-popup').bind('click', () => {
		togglePopup('contact-us');
  });

  document.addEventListener('keyup', (e) => {
  	console.log(e.code === 'Escape' && $('.popup.shown').length !== 0);
  	if(e.code === 'Escape' && $('.popup.shown').length !== 0) {
			togglePopup('contact-us');
		}
  });
});


function togglePopup(name) {
  	$(`.${name}-popup`).toggleClass('shown');
    //$('body').toggleClass('locked');
    $('html').toggleClass('locked');
    $('.screen-1__textblock').toggleClass('hidden');
}
